/* file description */

import { Button, Drawer, message, Modal, Popconfirm } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { delAssetData, deleteAssetCascadeData } from '@/api/cascade';
import { ExclamationCircleFilled, CloseOutlined } from '@ant-design/icons';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import RuleController from '@/components/RuleController';
import SpQiankun from '@/components/sp-qiankun';
import { ModuleInfo } from '@/common/model-apis/type';
import useMetaStore from '@/store/useMetaStore';
import { AbilityPoint } from '@/const';

const { confirm } = Modal;
interface OfficialRowPropsType {
  rowIndex: number;
  taskId: string;
  record: any;
  rowBtns: string[];
  tableWithRef: any;
  utils: any;
  moduleID: string;
  openVersion?: boolean;
  reload: () => void;
  optionsActionType: string;
  moduleInfo?: ModuleInfo;
  qiankun: Record<string, any>;
}

const OfficialRow: React.FC<OfficialRowPropsType> = function (props) {
  const [open, setOpen] = useState(false);
  const [targetUrl, setTargetUrl] = useState('');
  const { isMobile } = useMetaStore();
  const { taskId, record, rowBtns, tableWithRef, moduleID, openVersion, optionsActionType, moduleInfo, qiankun } = props;

  // const recordId = record.RECORD.recordID;
  const recordId = record?._id;
  const meta = useMetaStore();

  const showDeleteConfirm = (event) => {
    if (!isMobile) {
      event?.stopPropagation();
    }
    confirm({
      title: '确定删除本条数据？',
      icon: <ExclamationCircleFilled />,
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      async onOk() {
        const delResult = await deleteAssetCascadeData({
          modelId: moduleInfo?.handle,
          recordId,
          taskId,
        });
        if (delResult.success) {
          // fix jira SPZN-9229
          isMobile ? tableWithRef.current.removeRow(props.rowIndex) : tableWithRef.current.reload();
          message.success('删除成功');
          return;
        }
        message.error('删除失败');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const saveCb = (tag: boolean) => {
    if (tag) {
      props?.reload && props.reload();
      setOpen(false);
    }
  };

  return (
    <>
      {
        rowBtns.includes('edit-btns') &&
        <RuleController id="edit-btns" data={{ [moduleID]: record }} ability={AbilityPoint.canUpdate} moduleCode={moduleInfo?.handle}>
          <ButtonLayout
            type="link"
            onClick={(e) => {
              if (!isMobile) {
                e?.stopPropagation();
              }

              const tabFrom = meta.utils.qiankun.name;
              let url = `/lcp/task/${taskId}/edit/${recordId}`;
              if (openVersion) {
                url += `?openVersion=true&version=${record.system_version}&tabFrom=${tabFrom}`;
              } else {
                url += `?tabFrom=${tabFrom}`;
              }

              if (optionsActionType === 'drawer') {
                setTargetUrl(url);
                setOpen(true);
                return;
              }
              props.utils?.buiNavigate({
                type: 'tab',
                path: url,
                title: 'EIMOS',
              });
            }}
          >
            编辑
          </ButtonLayout>
        </RuleController>
      }
      {
        rowBtns.includes('view-btns') &&
        <RuleController id="view-btns" data={{ [moduleID]: record }} ability={AbilityPoint.canView} moduleCode={moduleInfo?.handle}>
          <ButtonLayout
            type="link"
            onClick={(e) => {
              if (!isMobile) {
                e?.stopPropagation();
              }
              let url = `/lcp/task/${taskId}/detail/${recordId}`;
              if (openVersion) {
                url += `?openVersion=true&version=${record.system_version}`;
              }

              if (optionsActionType === 'drawer') {
                setTargetUrl(url);
                setOpen(true);
                return;
              }
              props.utils?.buiNavigate({
                type: 'tab',
                path: url,
                title: 'EIMOS',
              });
            }}
          >
            查看
          </ButtonLayout>
        </RuleController>

      }
      {
        rowBtns.includes('delete-btns') &&
        <RuleController id="delete-btns" data={{ [moduleID]: record }} ability={AbilityPoint.canDelete} moduleCode={moduleInfo?.handle}>
          <ButtonLayout type="link" danger onClick={showDeleteConfirm}>
            删除
          </ButtonLayout>
        </RuleController>
      }
      <Drawer
        contentWrapperStyle={{ minWidth: '40%' }}
        placement="right"
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        maskClosable={false}
      >
        <div style={{ position: 'absolute', right: 0, top: 0, padding: 12, zIndex: 9999, cursor: 'pointer' }} onClick={() => setOpen(false)}>
          <CloseOutlined />
        </div>
        <SpQiankun
          saveCb={saveCb}
          routeUrl={targetUrl}
          qiankun={qiankun}
        />
      </Drawer>
    </>
  );
};

export default OfficialRow;
